import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GlobalService } from 'src/app/app-core/lib/global.service';
import $ from 'jquery';
import { OrganizationEnum } from 'src/app/Enums/organizationEnum';
import { UserDataRequestService } from 'src/app/app-core/services/user-data-request.service';
import { UserService } from 'src/app/app-core/services/user.service';
import { FiscoService } from 'src/app/app-core/services/fisco.service';
import { LocalStorageService } from 'src/app/app-core/services/local-storage.service';
import { RqTitlePipe } from 'src/app/app-core/lib/rq-title.pipe';

/** Tipo do anexo exigido no período do REFIS, no lugar dos anexos do assunto. */
const REFIS_DOCUMENT = 'DOCUMENTOS DO REFIS';

@Component({
    selector: 'app-attachments-request',
    templateUrl: './attachments-request.component.html',
    styleUrls: ['./attachments-request.component.scss'],
    providers: [UserService, LocalStorageService]
})
export class AttachmentsRequestComponent implements OnInit, OnChanges {

    @Input() attachments: any[];
    @Input() orgao: any;
    @Input() subjectFormLink: string;
    @Input() subjectGuidelinesLink: string;
    @Input() haveSign: boolean;
    @Input() isOrgaoFiscalizador: boolean;

    public allowedFileMimeTypes: string[] = [
        'application/pdf',
        'application/x-zip-compressed',
        'application/x-rar-compressed',
        'application/zip',
        'application/vnd.rar',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'image/jpeg',
        'image/png',
        'image/gif',
        'image/bmp',
        'image/webp',
        'image/tiff',
        'image/svg+xml'
    ];

    public mimeTypePdf = [
        'application/pdf',
        'application/zip',
        'application/vnd.rar',
        'application/x-zip-compressed',
        'application/x-rar-compressed',
    ]

    public entity: any;
    public modalTitle: string;
    public modalLink: string;
    public isAttached = false;
    public semurbNumber = OrganizationEnum.SEMURB;
    public documentRequiredName = "REQUERIMENTO"

    // arquivos restaurados do localStorage, agrupados por typeDocument, no formato do input [files] do dropzone
    public storedFiles: { [typeDocument: string]: any[] } = {};

    protected isRefisPeriodActive: boolean;

    private localStorageKey = 'attachments-request-documentos';

    constructor(
        public global: GlobalService,
        private userDataRequestService: UserDataRequestService,
        private userService: UserService,
        private fiscoService: FiscoService,
        private localStorageService: LocalStorageService,
    ) {
        this.entity = this.defaults();
        this.getFromLocalStorage();
    }

    ngOnInit(): void {
        this.documentRequiredName = (this.isOrgaoFiscalizador)? "OFÍCIO" : "REQUERIMENTO"
        this.getRefisPeriodStatus();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.attachments) {
            this.verifyUploadedAttachments();
        }

        if (changes.isOrgaoFiscalizador) {
            this.documentRequiredName = (this.isOrgaoFiscalizador)? "OFÍCIO" : "REQUERIMENTO"
        }
    }

    public defaults() {
        return {
            documentos: {
                procuracao: [],
                requerimento: [],
                complementar: []
            }
        }
    }

    private getFromLocalStorage(): void {
        const storageData = this.localStorageService.get<any>(this.localStorageKey);

        if (storageData && typeof storageData === 'object') {
            this.entity.documentos = {
                ...this.entity.documentos,
                ...storageData,
            };

            const files = [...this.entity.documentos.requerimento, ...this.entity.documentos.complementar];
            files.forEach(file => {
                (this.storedFiles[file.typeDocument] ??= []).push({
                    SOLA_Nome: file.name,
                    SOLA_Anexo: file.url,
                });
            });
        }
    }

    private saveOnLocalStorage(): void {
        this.localStorageService.set(this.localStorageKey, this.entity.documentos);
    }

    public clearLocalStorage(): void {
        this.localStorageService.remove(this.localStorageKey);
    }

    // chamado quando o assunto muda: os anexos enviados pertencem ao assunto anterior
    public resetDocuments(): void {
        this.entity = this.defaults();
        this.isAttached = false;
        this.clearLocalStorage();

        // arrays novos forçam o ngOnChanges dos dropzones que continuam na tela a zerar a lista exibida
        const types = [...Object.keys(this.storedFiles), this.documentRequiredName, 'DOCUMENTOS DO REFIS', 'complementar'];
        this.storedFiles = {};
        types.forEach(type => this.storedFiles[type] = []);
    }

    public getUploadedFile(event: any, attachment = null) {
        let file = event.file;

        if (file.typeDocument != 'complementar') {
            if (attachment) {
                file = {
                    ...file,
                    ANX_Obrigatorio: attachment.ANX_Obrigatorio
                };
            }
            if (file.typeDocument == this.documentRequiredName) {
                file = {
                    ...file,
                    ANX_Obrigatorio: true
                };
            }
            this.entity.documentos['requerimento'].push(file);
        }
        else {
            this.entity.documentos[file.typeDocument].push(file);
        }
        this.verifyUploadedAttachments();
        this.saveOnLocalStorage();
    }

    private verifyUploadedAttachments() {

        if (!this.showDocumentRefis) {
            const attachmentsMandatory = this.attachments.filter((attachment) => attachment.ANX_Obrigatorio);
            let allMandatoryAttached = true;
            for (const attachment of attachmentsMandatory) {
                const list = this.entity.documentos.requerimento.find((item) => item.typeDocument == attachment.ANX_Nome);
    
                if (!list) allMandatoryAttached = false; 
            }
    
            (!allMandatoryAttached)? this.isAttached = false : this.isAttached = true;
        }
        else {
            this.isAttached = true;
        }

        const requerimento = this.entity.documentos.requerimento.filter((item) => item.typeDocument == this.documentRequiredName);

        if (requerimento.length == 0 && !this.haveSign) {
            this.isAttached = false
        }

        if (requerimento.length == 0 && this.haveSign && this.isOrgaoFiscalizador) {
            this.isAttached = false
        }

        if (this.showDocumentRefis) {
            const refis = this.entity.documentos.requerimento.filter((item) => item.typeDocument == "DOCUMENTOS DO REFIS");
            if (refis.length == 0) {
                this.isAttached = false;
            }
        }

    }

    public onDeleteFileUploaded(event: any) {
        let file = event;
        if (file.typeDocument != 'procuracao' && file.typeDocument != 'complementar') {
            for (let i = 0; i < this.entity.documentos.requerimento.length; i++) {
                if (file.typeDocument == this.entity.documentos.requerimento[i].typeDocument) {
                    this.entity.documentos['requerimento'].splice(i, 1);
                }
            }
        }
        else {
            const documentosArray = this.entity.documentos[event.typeDocument];

            if (documentosArray && documentosArray.length > event.index) {
                documentosArray.splice(event.index, 1);
            }
        }
        this.verifyUploadedAttachments();
        this.saveOnLocalStorage();
    }

    public get organizationIsSemurb() {
        return this.semurbNumber === this.orgao?.OR_NumeroOrgao;
    }

    openFileModal(type: 'guidelines' | 'form') {
        const isPdfLink = (link) => link && link.toLowerCase().endsWith('.pdf');

        this.modalLink = type === 'guidelines' ? this.subjectGuidelinesLink : this.subjectFormLink;

        if (isPdfLink(this.modalLink)) {
            this.modalTitle = type === 'guidelines' ? 'Orientações' : 'Modelo do requerimento';
            $('#file-dialog').modal('show');
        } else if (this.modalLink) {
            // Link que não é PDF (uma página, uma pasta compartilhada) abre fora do sistema.
            window.open(this.modalLink, '_blank', 'noopener');
        }
    }
    

    // ------------------------------------------------------------------
    // Lista de conferência dos documentos
    // ------------------------------------------------------------------

    /** Tipos de documento obrigatórios nesta solicitação, na ordem em que aparecem. */
    public get requiredTypes(): string[] {
        const tipos: string[] = [];

        if (!this.haveSign || this.isOrgaoFiscalizador) tipos.push(this.documentRequiredName);

        if (this.showDocumentRefis) {
            tipos.push(REFIS_DOCUMENT);
        } else {
            (this.attachments || []).filter((anexo) => anexo.ANX_Obrigatorio).forEach((anexo) => tipos.push(anexo.ANX_Nome));
        }

        return tipos;
    }

    public isDone(tipo: string): boolean {
        return this.entity.documentos.requerimento.some((arquivo) => arquivo.typeDocument === tipo);
    }

    public get requiredDone(): number {
        return this.requiredTypes.filter((tipo) => this.isDone(tipo)).length;
    }

    public get complementaryCount(): number {
        return this.entity.documentos.complementar.length;
    }

    /** Por que ainda não dá para sair da etapa; null quando dá. */
    public get pendingReason(): string | null {
        if (this.isAttached) return null;

        const faltam = this.requiredTypes.filter((tipo) => !this.isDone(tipo));

        if (faltam.length === 1) return `Falta anexar: ${new RqTitlePipe().transform(faltam[0])}.`;
        if (faltam.length > 1) return `Faltam ${faltam.length} documentos obrigatórios.`;

        return 'Anexe os documentos obrigatórios para continuar.';
    }

    public get refisDocument(): string {
        return REFIS_DOCUMENT;
    }

    closeFileModal() {
        $('#file-dialog').modal('hide');
    }

    getRefisPeriodStatus() {
        this.userDataRequestService.getRefisPeriodStatus().subscribe({
            next: (isActive: boolean) => {
                this.isRefisPeriodActive = isActive;
            }
        })
    }

    get showDocumentRefis(): boolean {
        return this.userService.isTriagem() && this.isRefisPeriodActive;
    }

    public downloadExtratoDivida(): void {
        const user = this.userService.getUser();

        if (!user || !user.PE_CPF) {
            alert('CPF não encontrado. Não é possível gerar o extrato.');
            return;
        }

        this.fiscoService.getPdfExtratoDivida(user.PE_CPF).subscribe({
            next: (response) => {
                if (response?.success && response?.url) {
                    window.open(response.url, '_blank');
                } else {
                    alert(response?.mensagem || 'Não foi possível gerar seu extrato.');
                }
            },
            error: (err) => {
                console.error('Erro ao gerar extrato da dívida', err);
                alert('Erro ao gerar extrato da dívida. Tente novamente mais tarde.');
            }
        });
    }
}
